// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-35cdb5c5] .custom-issued-policies-chart-tooltip{padding:5px;display:flex;flex-direction:column;align-items:start;justify-content:flex-start;font-size:12px}", ""]);
// Exports
module.exports = exports;
